import { defineComponent as _defineComponent } from 'vue'
import {
  PaginatedQuery,
  ClientInvite,
  ClientInviteListFilters,
  PaginatedResponse,
  ProductStatus,
  showProducts,
} from 'ah-api-gateways';
import { computed, PropType, useAttrs, useListeners } from 'vue';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useServices } from 'bd-common/src/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { capitalize } from 'lodash';

interface InivitedClientEmit extends UseManagedListingEmits<ClientInvite> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: [] }),
  },
  ...defineUseManagedListingProps<ClientInvite>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const services = useServices();
const attrs = useAttrs();
const listeners = useListeners();



const managedListing = useManagedListing<ClientInvite>({
  loadDataRequest(query: PaginatedQuery<ClientInviteListFilters>) {
    // FIXME - we need to update this with the products endpoint
    return services.clientInvites.listClientInvites(query).pipe(
      mergeMap(() => {
        const empty = {
          list: [
            {
              sellCurrency: 'EUR',
              buyCurrency: 'GBP',
              currencyPair: 'EURGBP',
              status: 'ENABLED',
              notionalAmount: 12,
              notionalCurrency: 'GBP',
              products: ['SPOT', 'FORWARD'],
            },
            {
              sellCurrency: 'AED',
              buyCurrency: 'USD',
              currencyPair: 'AEDUSD',
              status: 'DISABLED',
              notionalAmount: 10000,
              notionalCurrency: 'AED',
              products: ['SPOT'],
            },
            {
              sellCurrency: 'AED',
              buyCurrency: 'USD',
              currencyPair: 'AEDUSD',
              status: 'DISABLED',
              notionalAmount: 200,
              notionalCurrency: 'AED',
              products: ['FORWARD'],
              updatedBy: 'Annie Appleseed',
              updatedAt: '2024-03-25T15:57:23.559Z',
              previousStatus: 'ENABLED',
              previousProducts: ['SPOT'],
            },
          ],
          pageNumber: 0,
          pageSize: 10,
          total: 3,
        } as PaginatedResponse<any>;
        return of(empty);
      })
    );
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

function iconName(status: ProductStatus) {
  return status === ProductStatus.ENABLED ? 'check_circle' : 'motion_photos_off';
}

function iconClass(status: ProductStatus) {
  return status === ProductStatus.ENABLED ? 'icon-enabled' : 'icon-disabled';
}

expose({ loadData: managedListing.loadData });

return { __sfc: true,props, services, attrs, listeners, emit, managedListing, iconName, iconClass, showProducts, MaterialIcon, formatCurrencyValue, capitalize }
}

})